
import { Instagram, Youtube } from "lucide-react";
import { FaTiktok } from "react-icons/fa";

const SocialMediaIcons = () => {
  return (
    <div className="flex gap-2">
      <a
        href="#"
        className="w-8 h-8 flex items-center justify-center rounded-full bg-gradient-to-tr from-purple-600 via-pink-600 to-yellow-500 hover:opacity-90 transition-opacity"
        aria-label="Instagram"
      >
        <Instagram className="h-4 w-4 text-white" />
      </a>
      <a
        href="#"
        className="w-8 h-8 flex items-center justify-center rounded-full bg-black hover:bg-gray-900 transition-colors"
        aria-label="TikTok"
      >
        <FaTiktok className="h-4 w-4 text-white" />
      </a>
      <a
        href="#"
        className="w-8 h-8 flex items-center justify-center rounded-full bg-red-600 hover:bg-red-700 transition-colors"
        aria-label="YouTube"
      >
        <Youtube className="h-4 w-4 text-white" />
      </a>
    </div>
  );
};

export default SocialMediaIcons;
